enum modal {
  NO = 'no',
  CHINA = 'china',
  INDIA = 'india',
  UZBEKISTAN = 'uzbekistan',
  BELARUS = 'belarus',
  ARMENIA = 'armenia',
  MOLDOVA = 'moldova',
  SERBIA = 'serbia',
  SOUTH_AFRICA = 'south-africa',
  BRAZIL = 'brazil',
  TUNISIA = 'tunisia',
  CUBA = 'cuba',
  EGYPT = 'egypt',
  UAE = 'uae',
  INDONESIA = 'indonesia',
}

enum content {
  NO = -1,
  SOUTH_AFRICA = 0,
  BRAZIL = 1,
  INDIA = 2,
  BELARUS = 3,
  SERBIA = 4,
  CHINA = 5,
  TUNISIA = 6,
  CUBA = 7,
  EGYPT = 8,
  UAE = 9,
  INDONESIA = 10,
  ARMENIA = 11,
  UZBEKISTAN = 12,
  MOLDOVA = 13,
}

export {
  modal,
  content
}
